var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout sample-profile type-profile"},[_c('sample-navbar'),_c('div',{staticClass:"wrapper",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('app-side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: '/sample/industry-market-profile/about-the-data',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Competitors',
            icon: 'location_on',
            path: '/sample/industry-market-profile/competitors',
          }}}),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'market' }),expression:"{ name: 'market' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Market',
              icon: 'trending_up',
              path: '/sample/industry-market-profile/market',
            }}})],1),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'balance-sheet' }),expression:"{ name: 'balance-sheet' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Annual Sales',
              icon: 'area_chart',
              path: '/sample/industry-market-profile/annual-sales',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Penetration',
            icon: 'business',
            path: '/sample/industry-market-profile/penetration',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Employment',
            icon: 'account_box',
            path: '/sample/industry-market-profile/employment',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Sales/Emp Classes',
            icon: 'price_change',
            path:
              '/sample/industry-market-profile/sales-emp-classes',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Productivity',
            icon: 'work',
            path: '/sample/industry-market-profile/productivity',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Startups',
            icon: 'settings_input_antenna',
            path: '/sample/industry-market-profile/startups',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cessation',
            icon: 'area_chart',
            path: '/sample/industry-market-profile/cessation',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Ownership',
            icon: 'location_city',
            path: '/sample/industry-market-profile/ownership',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Demographics',
            icon: 'home',
            path: '/sample/industry-market-profile/demographics',
          }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }